var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-data-table',{attrs:{"headers":_vm.tableHeaders,"items":_vm.items,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }